/**
 * Montaje único y central del cierre de sesión por inactividad.
 *
 * Se renderiza una sola vez dentro de <BrowserRouter> (App.tsx) — no toca
 * PanelLayout / AdminLayout / área paciente. Sin sesión no hace nada (el hook
 * no corre timers para anónimo). Cuando corresponde, muestra el aviso del
 * motivo (inactividad o duración máxima).
 */
import { useIdleLogout } from '@/hooks/useIdleLogout';
import SessionTimeoutModal from './SessionTimeoutModal';

export default function SessionGuard() {
  const {
    warningKind,
    secondsLeft,
    maxHours,
    keepAlive,
    logoutNow,
    consultationSave,
    retryConsultationSave,
  } = useIdleLogout();
  if (!warningKind) return null;
  return (
    <SessionTimeoutModal
      kind={warningKind}
      secondsLeft={secondsLeft}
      maxHours={maxHours}
      onKeep={keepAlive}
      onLogout={logoutNow}
      consultationSave={consultationSave}
      onRetrySave={retryConsultationSave}
    />
  );
}
